import { type MaterialComponentInputValue, useApiTradeV1BuyerMaterialSpecificationsCreate } from 'api';
import { useNavigate, useParams } from 'react-router-dom';

import { type UploadGenericDocumentProps } from '../../../document';
import { getBuyerMaterialSpecificationUrl } from '../../utils/getBuyerMaterialSpecificationListUrl/getBuyerMaterialSpecificationUrl';
import { useUploadAndCreateDocument } from '../useUploadAndCreateDocument/useUploadAndCreateDocument';

type CreateBuyerMaterialSpecificationProps = {
  buyerId: number;
  materialGradeId: number;
  materialId: number;
  materialFormId: number;
  materialColourId?: number;
  materialComponents: MaterialComponentInputValue[];
  notes: string | undefined;
  document?: UploadGenericDocumentProps;
  packagingSpecificationIds: number[];
};

type HookProps = {
  onError?: (error: Error) => void;
};
export const useCreateBuyerMaterialSpecification = ({ onError }: HookProps) => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const uploadDocument = useUploadAndCreateDocument();
  const { mutateAsync, isPending } = useApiTradeV1BuyerMaterialSpecificationsCreate({
    mutation: {
      onError: (error) => {
        onError?.(error);
      },
    },
  });

  const createBuyerMaterialSpecification = async ({
    buyerId,
    materialGradeId,
    materialId,
    materialFormId,
    materialColourId,
    materialComponents,
    notes,
    document,
    packagingSpecificationIds,
  }: CreateBuyerMaterialSpecificationProps) => {
    await mutateAsync({
      data: {
        buyer_id: buyerId,
        material_colour_id: materialColourId,
        material_component_values: materialComponents,
        material_form_id: materialFormId,
        material_grade_id: materialGradeId,
        material_id: materialId,
        notes: notes,
        packaging_specification_ids: packagingSpecificationIds,
      },
    }).then(async (data) => {
      if (document) {
        await uploadDocument(data.id, document);
      }
      navigate(getBuyerMaterialSpecificationUrl(Number(companyId)));
    });
  };
  return { createBuyerMaterialSpecification, isPending };
};
